module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento7.ac6386b1.svg";